import { useQuery } from "@tanstack/react-query";
import {
  getOnboardingChecklist,
  OnboardingChecklistResponse
} from "api/onboarding-checklist";

const ONBOARDING_CHECKLIST_QUERY_KEY = ["ONBOARDING_CHECKLIST"];

// Pass `enabled` reflecting the flag + admin gate to avoid a 404/403 request.
export const useOnboardingChecklistController = ({
  enabled = true
}: { enabled?: boolean } = {}) => {
  const checklistMeta = useQuery<OnboardingChecklistResponse>({
    queryKey: ONBOARDING_CHECKLIST_QUERY_KEY,
    queryFn: getOnboardingChecklist,
    enabled
  });

  return { checklistMeta };
};
